// @module Tavanoteam.PLPBackorderMessage.PLPBackorderMessage
define("Tavanoteam.PLPBackorderMessage.PLPBackorderMessage.View", [
  "tavanoteam_plpbackordermessage_plpbackordermessage.tpl",
  "Backbone",
  "Tavanoteam.PLPBackorderMessage.BackOrderMessageModal.View"
], function (
  tavanoteam_plpbackordermessage_plpbackordermessage_tpl,
  Backbone,
  BackOrderModalView
) {
  "use strict";

  // @class Tavanoteam.PLPBackorderMessage.PLPBackorderMessage.View @extends Backbone.View
  return Backbone.View.extend({
    template: tavanoteam_plpbackordermessage_plpbackordermessage_tpl,

    initialize: function (options) {
      this.plp = options.container.getComponent("PLP");
      this.pdp = options.container.getComponent("PDP");
      this.pdpView = options.container.layout.currentView.$el[0].id;
      this.container = options.container;
      this.layout = options.container.getComponent("Layout");
      var self = this;
      this.items = this.plp.getItemsInfo();
      this.item;
      this.product = this.pdp.getItemInfo();
      this.isPdp = false;
      if (this.pdpView && this.pdpView == "ProductDetails.Full.View") {
        this.isPdp = true;
      }

      this.pdp.on('afterOptionSelection', function (data) {
        self.render();
      });

      this.layout.on("afterShowContent", function () {
        if (self.items) {
          self.itemId = jQuery(self.$el.offsetParent()[0].children).attr("data-item-id");
          self.item = _.filter(self.items, function (item) {
            return item.internalid == self.itemId;
          })[0];
          self.isPdp = false;
          self.render();
        } else if (self.product) {
          self.render();
        }

      });
    },

    events: {
      'click [data-action="show-modal"]': "showModal"
    },

    bindings: {},

    childViews: {},

    showModal: function showModal(event) {
      var view = event.currentTarget.dataset.source;
      if (view == "plp") {
        this.isPdp = false;
      }
      var view = new BackOrderModalView({
        container: this.container,
        item: this.item
      });
      this.layout.showContent(view, { showInModal: true });
    },

    //@method getContext @return Tavanoteam.PLPBackorderMessage.PLPBackorderMessage.View.Context
    getContext: function getContext() {

      if (this.pdp && this.isPdp) {
        // Get all the child items of the selected item (if any)
        var childs = this.pdp.getSelectedMatrixChilds();
        this.isPdp = true;

        if (childs && childs.length === 1) {
          this.item = childs[0];
        } else {
          if (this.pdp.getItemInfo()) {
            this.item = this.pdp.getItemInfo().item;
          }
        }
      } else {
        this.isPdp = false;
      }

      if (this.item && this.item.isinstock == false || this.item && this.item.isinstock == 'No') {
        this.isOutOfStock = true;
      } else {
        this.isOutOfStock = false;
      }
      this.inStockMessage = (this.item && this.item.isinstock && this.item.inStockMessage) || "In Stock";
      return {
        isOutOfStock: this.isOutOfStock,
        inStockMessage: this.inStockMessage,
        isPdp: this.isPdp
      };
    }
  });
});
